module.exports = __webpack_public_path__ + "img/page.45ec98a5.png";